import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { UserContext } from '../../core/contexts/UserContext.jsx'

const PrivateRoute = ({ children }) => {
  const context = useContext(UserContext)

  // Fallback if context is null (initialization issue)
  if (!context) {
    console.warn('UserContext is null in PrivateRoute - redirecting to login')
    return <Navigate to="/login" />
  }

  const { isAuthenticated, loading } = context

  if (loading) return <></>

  return isAuthenticated ? children : <Navigate to="/login" />
}

const PublicRoute = ({ children }) => {
  const context = useContext(UserContext)

  // Fallback if context is null (initialization issue)
  if (!context) {
    console.warn('UserContext is null in PublicRoute')
    return children
  }

  const { isAuthenticated, loading } = context

  if (loading) return <></>

  return !isAuthenticated ? children : <Navigate to="/" />
}

export { PrivateRoute, PublicRoute }
